// メッセージボックス_OK_CANCEL用棚
import React, { useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
var DialogConfirm = function (_a) {
    var label = _a.label, body = _a.body, ok = _a.ok, okCallback = _a.okCallback, cancel = _a.cancel, cancelCallback = _a.cancelCallback, open = _a.open;
    var handleClickOk = function (event) {
        okCallback(event);
    };
    var handleClickCancel = useCallback(function (event) {
        cancelCallback(event);
    }, []);
    return (React.createElement("div", { className: "dialog-confirm" },
        React.createElement("div", { className: "dialog-mask", style: { display: open ? 'block' : 'none' } }),
        React.createElement("div", { className: "dialog-section", style: { display: open ? 'block' : 'none' } },
            React.createElement("div", { className: "dialog-inner" },
                React.createElement("div", { className: "dialog-contents" },
                    React.createElement("h3", null, label),
                    React.createElement("div", { className: "dialog-body" }, body),
                    React.createElement(Row, { className: "dialog-button" },
                        React.createElement(Col, { xl: 6, lg: 6, md: 6, sm: 6, xs: 6 },
                            React.createElement("button", { className: "c-btn btn-large btn-red btn-ok", type: "button", onClick: handleClickOk }, ok)),
                        React.createElement(Col, { xl: 6, lg: 6, md: 6, sm: 6, xs: 6 },
                            React.createElement("button", { className: "c-btn btn-large btn-main-color btn-cancel mr-0 ml-auto", type: "button", onClick: handleClickCancel }, cancel))))))));
};
export default DialogConfirm;
